/**
 * Mock data for table players with their selected characters
 * Used for testing table availability and character selection scenarios
 */

// Available character IDs from character_cards_data.json (1-16)
export const mockPlayers = {
  // Table 1: Veterans Table
  table1: [
    {
      id: "player_joao",
      username: "João",
      selectedCharacters: [1, 5], // Kaique Freitosa, Jonatas Vieira
    },
    {
      id: "player_maria",
      username: "Maria",
      selectedCharacters: [2, 6], // Ana Carolina, Rafael Santos
    },
    {
      id: "player_pedro",
      username: "Pedro",
      selectedCharacters: [3], // Lucas Mendes
    },
  ],

  // Table 2: Epic Adventure
  table2: [
    {
      id: "player_ana",
      username: "Ana",
      selectedCharacters: [4, 8], // Beatriz Lima, Eduardo Costa
    },
    {
      id: "player_carlos",
      username: "Carlos",
      selectedCharacters: [7], // Mariana Souza
    },
  ],

  // Table 3: Dragon Battle (playing - 4 players)
  table3: [
    {
      id: "player_lucas",
      username: "Lucas",
      selectedCharacters: [1, 2, 3], // Full roster
    },
    {
      id: "player_fernanda",
      username: "Fernanda",
      selectedCharacters: [4, 5], // 2 characters
    },
    {
      id: "player_ricardo",
      username: "Ricardo",
      selectedCharacters: [6, 7, 8], // Full roster
    },
    {
      id: "player_paula",
      username: "Paula",
      selectedCharacters: [9, 10], // 2 characters
    },
  ],

  // Table 4: Full Table (6 players)
  table4: [
    {
      id: "player_p1",
      username: "Player1",
      selectedCharacters: [1],
    },
    {
      id: "player_p2",
      username: "Player2",
      selectedCharacters: [2, 3],
    },
    {
      id: "player_p3",
      username: "Player3",
      selectedCharacters: [4],
    },
    {
      id: "player_p4",
      username: "Player4",
      selectedCharacters: [5, 6],
    },
    {
      id: "player_p5",
      username: "Player5",
      selectedCharacters: [7],
    },
    {
      id: "player_p6",
      username: "Player6",
      selectedCharacters: [8, 9],
    },
  ],

  // Table 5: Beginners Welcome (only host)
  table5: [
    {
      id: "player_host",
      username: "HostPlayer",
      selectedCharacters: [],
    },
  ],

  // Table 6: Hardcore Private Campaign
  table6: [
    {
      id: "player_elite1",
      username: "Elite1",
      selectedCharacters: [11, 12, 13], // Full elite roster
    },
    {
      id: "player_elite2",
      username: "Elite2",
      selectedCharacters: [14, 15],
    },
    {
      id: "player_elite3",
      username: "Elite3",
      selectedCharacters: [16, 1, 2], // Mix of characters
    },
  ],

  // Table 7: Completed Journey
  table7: [
    {
      id: "player_winner1",
      username: "Winner1",
      selectedCharacters: [3, 4, 5],
    },
    {
      id: "player_winner2",
      username: "Winner2",
      selectedCharacters: [6, 7],
    },
    {
      id: "player_winner3",
      username: "Winner3",
      selectedCharacters: [8, 9, 10],
    },
    {
      id: "player_winner4",
      username: "Winner4",
      selectedCharacters: [11, 12],
    },
  ],

  // Table 8: Last Spot Available (5 players)
  table8: [
    {
      id: "player_p1_t8",
      username: "P1",
      selectedCharacters: [1, 2],
    },
    {
      id: "player_p2_t8",
      username: "P2",
      selectedCharacters: [3],
    },
    {
      id: "player_p3_t8",
      username: "P3",
      selectedCharacters: [4, 5],
    },
    {
      id: "player_p4_t8",
      username: "P4",
      selectedCharacters: [6],
    },
    {
      id: "player_p5_t8",
      username: "P5",
      selectedCharacters: [7, 8, 9],
    },
  ],

  // Table 9: Duelo 1v1 (2 players)
  table9: [
    {
      id: "player_duelist1",
      username: "Duelist1",
      selectedCharacters: [10, 11, 12],
    },
    {
      id: "player_duelist2",
      username: "Duelist2",
      selectedCharacters: [13, 14, 15],
    },
  ],

  // Table 10: Mega Raid Boss (8 players)
  table10: [
    {
      id: "player_raider1",
      username: "Raider1",
      selectedCharacters: [1],
    },
    {
      id: "player_raider2",
      username: "Raider2",
      selectedCharacters: [2],
    },
    {
      id: "player_raider3",
      username: "Raider3",
      selectedCharacters: [3],
    },
    {
      id: "player_raider4",
      username: "Raider4",
      selectedCharacters: [4],
    },
    {
      id: "player_raider5",
      username: "Raider5",
      selectedCharacters: [5],
    },
    {
      id: "player_raider6",
      username: "Raider6",
      selectedCharacters: [6],
    },
    {
      id: "player_raider7",
      username: "Raider7",
      selectedCharacters: [7],
    },
    {
      id: "player_raider8",
      username: "Raider8",
      selectedCharacters: [8],
    },
  ],

  // Table 11: Paused Table
  table11: [
    {
      id: "player_active1",
      username: "ActivePlayer1",
      selectedCharacters: [9, 10],
    },
    {
      id: "player_active2",
      username: "ActivePlayer2",
      selectedCharacters: [11],
    },
    {
      id: "player_active3",
      username: "ActivePlayer3",
      selectedCharacters: [12, 13],
    },
  ],

  // Table 12: VIP Waiting Room
  table12: [
    {
      id: "player_organizador",
      username: "OrganizadorHost",
      selectedCharacters: [],
    },
  ],
};

/**
 * Get available character IDs for a table
 * (Characters not yet selected by any player in that table)
 * @param {string} tableKey - Table key (e.g., "table1")
 * @param {number} totalCharacters - Total number of characters available (default 16)
 * @returns {number[]} Array of available character IDs
 */
export const getAvailableCharacters = (tableKey, totalCharacters = 16) => {
  const tablePlayers = mockPlayers[tableKey] || [];
  const selectedIds = new Set();

  tablePlayers.forEach((player) => {
    player.selectedCharacters.forEach((charId) => selectedIds.add(charId));
  });

  const available = [];
  for (let i = 1; i <= totalCharacters; i++) {
    if (!selectedIds.has(i)) {
      available.push(i);
    }
  }

  return available;
};
